import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import CompanyLogo from "../../common/assests/reyleafLogo.svg";
import Paginations from "../../common/pagination/Paginations";
import { useSelector } from "react-redux";
import { allForumListApi } from "../../api";
import { useParams } from "react-router-dom";
import { AdminTable } from "../../common/adminTable";
import configuration from "../../config/Config";

const JoinedForum = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [forumDataList, setForumeDataList] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);

  const handleForumList = async () => {
    try {
      setLoading(true);
      const response = await allForumListApi({ token, currentPage, id });
      setForumeDataList(response?.data || []);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    handleForumList();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  const columns = [
    {
      field: "picture",
      headerName: "Image",
      width: 70,
      renderCell: (row) => (
        <img
          src={row?.picture ? `${configuration.cdnFront}/${row.picture}` : CompanyLogo}
          alt="forum"
          style={{ height: 40, width: 40, borderRadius: "6px", objectFit: "cover" }}
        />
      ),
    },
    { field: "title", headerName: "Title", minWidth: 160, renderCell: (r) => r?.title || "-" },
    { field: "joinedCount", headerName: "Members", width: 100, renderCell: (r) => r?.joinedCount ?? 0 },
    {
      field: "description",
      headerName: "Description",
      minWidth: 200,
      cellSx: { maxWidth: 300, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
      renderCell: (r) => r?.description || "-",
    },
  ];

  return (
    <Box sx={{ mt: "40px", mb: "30px" }}>
      <Typography sx={{ fontSize: "20px", fontWeight: "500", color: "#362B24", fontFamily: "Heebo", mb: 2 }}>
        All Platform Events
      </Typography>
      <AdminTable
        columns={columns}
        rows={forumDataList}
        loading={loading}
        rowKey="_id"
        emptyText="No forums found"
      />
      <Paginations
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        disabled={loading}
      />
    </Box>
  );
};

export default JoinedForum;
